import React from 'react';
import Button from '@mui/material/Button';
import { useDebriefModal } from 'ff/debrief/modalManager';
import SaveAltIcon from '@mui/icons-material/SaveAlt';

const ImportsButton = () => {
    const { open: openImports } = useDebriefModal('Imports');
    const handleClick = () => {
        openImports();
    };

    return (
        <Button
            variant="outlined"
            onClick={handleClick}
            sx={{ width: '98%', mx: 'auto', display: 'flex' }}
            size="small"
            startIcon={<SaveAltIcon />}
        >
            Import Flight
        </Button>
    );
};

export default ImportsButton;
